import { useParams } from "react-router-dom";
import { useOrganisation } from "../../../../../../providers/OrganisationProvider";
import { RegistrationConfirmPage } from "../../../../../../layout/registration/RegistrationConfirmPage";

const SeriesRegistrationConfirmPage = () => {
    const { shortName, seriesId } = useParams();
    const organisation = useOrganisation();

    const series = organisation?.series.find(s => s.id === seriesId);

    return (
        <RegistrationConfirmPage
            crumbs={[{ text: organisation?.name, link: `/${organisation?.shortName}` }]}
            current={series?.name}
            title="Member registration"
            registrationUrl={`/${shortName}/series/${seriesId}/sign-on`}
            successUrl={`/${shortName}/series/${seriesId}/sign-on/success`}
        />
    );
};
export default SeriesRegistrationConfirmPage;

